/**
 * Automy.Core.Enums.Reporting.Queries.ReportingQueryMetricOperation
 * Native queries[].metrics[].operation (string token).
 */
export default Object.freeze({
  Count: 'count',
  CountDistinct: 'count-distinct',
  Sum: 'sum',
  Average: 'average',
  Min: 'min',
  Max: 'max',
});
